import React, { useState } from "react"
import { Drawer } from "vaul"

import GatsbyStoryblokImage from "../GatsbyStoryblokImage"
import Typography from "../Typography"

import VideoModal from "@components/experiments/VideoModal"
import { Color } from "@constants/V2/color"

type Props = {
  color: Color
  linkText: string
  linkUrl: string | YocoCom.YocoLink | undefined
  videoCoverImage: string
}

const VideoButton = ({ color, linkText, linkUrl, videoCoverImage }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Drawer.Root open={isModalOpen} onOpenChange={() => setIsModalOpen(false)}>
      <VideoModal
        videoUrl={typeof linkUrl === "string" ? linkUrl : (linkUrl?.url ?? "")}
        coverImage={videoCoverImage}
        imageAlt={""}
        title={""}
      />

      <button
        onClick={() => setIsModalOpen(true)}
        className="group m-auto mt-8 flex items-center justify-center sm:m-[inherit] sm:mt-32 sm:justify-start"
      >
        <Typography
          text={linkText}
          font="grotesk"
          weight="medium"
          size="body-lg"
          color={color}
          className="mb-auto mr-10 mt-auto group-hover:text-blue"
        />

        <div className="flex h-[24px] w-[24px] items-center justify-center rounded-full border-[1.5px] border-blue transition-colors duration-300 group-hover:bg-blue group-hover:bg-opacity-50">
          <GatsbyStoryblokImage
            image="/icons/experiments/play-blue.svg"
            alt="Play icon"
            height={10}
            width={10}
            className="relative left-[1px]"
          />
        </div>
      </button>
    </Drawer.Root>
  )
}

export default VideoButton
